import produce from 'immer';

import { type MemoizedContextAction } from '@air/react-memoized-context';

import {
  type AnnotationContextValue,
  AnnotationProviderActions,
} from '~/providers/AnnotationProvider/annotationProviderTypes';

export const annotationsDispatch = (state: AnnotationContextValue, action: MemoizedContextAction) => {
  switch (action.type) {
    case AnnotationProviderActions.setActiveAnnotation: {
      return produce(state, (draft) => {
        draft.activeAnnotation = action.data;
      });
    }
  }

  return state;
};

export const activeAnnotationSelector = (state: AnnotationContextValue) => state.activeAnnotation;
